require('./RACommissionCondition.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @assets
const icon3 = require('../../assets/icons/icon3-footer.svg');

class RACommissionCondition extends React.Component {
    render() {
        const { modifier, showImage } = this.props;
        const classname = modifier
            ? 'ra-commission-condition__primary'
            : 'ra-commission-condition__disclaimer';

        return (
            <React.Fragment>
                {showImage ? (
                    <img
                        className="ra-commission-condition__icon"
                        src={icon3}
                    />
                ) : null}
                <FormattedText
                    value="raCommissionCondition-raCommissionCondition_disclaimer"
                    className={classname}
                />
            </React.Fragment>
        );
    }
}

RACommissionCondition.propTypes = {
    modifier: PropTypes.bool,
    showImage: PropTypes.bool,
};

RACommissionCondition.defaultProps = {
    modifier: false,
    showImage: true,
};

module.exports = RACommissionCondition;
